import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=26e1ac1b"
import script from "./ModelForm.vue?vue&type=script&lang=ts"
export * from "./ModelForm.vue?vue&type=script&lang=ts"
import style0 from "./ModelForm.vue?vue&type=style&index=0&id=26e1ac1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports